import startImg from "../../../assets/loan-interactive/instruction/play_icon.png";
import pauseImg from "../../../assets/loan-interactive/instruction/pause_icon.png";

function InsPH() {
  return (
    <>
      <h1 style={{ paddingBottom: "2rem" }}>Ano ang Loan?</h1>
      <p style={{ paddingBottom: "1.5rem" }}>
        Kumusta! Welcome sa Quick Learning Tool No. 4: Ano ang Loan?
      </p>

      <p style={{ paddingBottom: "3.5rem" }}>
        Sa pamamahala ng pera, mahalaga na maunawaan ang basics ng isang loan.
      </p>

      <h2 style={{ paddingBottom: "2rem" }}>Gabay</h2>
      <p style={{ paddingBottom: "2rem" }}>
        Una, i-click ang "Start (Filipino)" button para makapasok sa interactive
        na mapa.
      </p>

      <p style={{ paddingBottom: "2rem" }}>
        Makakakita ka ng limang mga vendor na maaaring i-click sa mapa. I-click
        muna ang "Manang Dang: Fishmonger" vendor para simulan ang iyong
        learning journey. Sundan ang mga hakbang na ito ayon sa tamang
        pagkakasunod-sunod:
      </p>

      <ol style={{ paddingBottom: "2rem" }}>
        <li>1. Manang Dang: Fishmonger</li>
        <li>2. Mareng Risa: Rice Dealer</li>
        <li>3. Madam Burda: Handicraftsman</li>
        <li>4. Ate Pan: Bakery Owner</li>
        <li>5. Kuya Pau: Loan Officer</li>
      </ol>

      <p style={{ paddingBottom: "2rem" }}>
        Kapag na-click mo na ang isang vendor, magbubukas ang isang usapan.
        Basahin ito nang mabuti.
      </p>

      <p style={{ paddingBottom: "2rem" }}>
        May sasagutan kang multiple-choice questions rito na may kinalaman sa
        basic na konsepto ng loan. Sagutin lamang ang mga tanong para
        makapagpatuloy.
      </p>

      <p style={{ paddingBottom: "2rem" }}>
        Kapag kailangan mong huminto, i-click ang icon na ito{" "}
        <img
          src={pauseImg}
          alt="pasue"
          style={{
            cursor: "pointer",
            marginLeft: "5px",
            height: ".7rem",
          }}
        />
        . Ito ay pansamantalang titigil sa kasalukuyang usapan. I-click ang{" "}
        <img
          src={startImg}
          alt="start"
          style={{
            cursor: "pointer",
            marginLeft: "5px",
            marginRight: "5px",
            height: ".7rem",
          }}
        />{" "}
        upang magpatuloy mula sa kung saan ka huling huminto.
      </p>
    </>
  );
}
export default InsPH;
